/** @jsxImportSource react */
import type { SVGProps } from 'react';
const Refresh = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M19.5 7.451V4.25a.75.75 0 1 1 1.5 0v5a.75.75 0 0 1-.75.75h-5a.75.75 0 1 1 0-1.5h3.122c-1.274-2.346-3.738-3.761-6.37-3.753a7.35 7.35 0 0 0-4.808 1.827A7.32 7.32 0 0 0 4.75 12a7.3 7.3 0 0 0 2.444 5.429A7.3 7.3 0 0 0 12 19.25a7.31 7.31 0 0 0 5.676-2.739.75.75 0 0 1 1.174.934A8.81 8.81 0 0 1 12 20.75a8.8 8.8 0 0 1-5.8-2.198 8.8 8.8 0 0 1-2.949-6.553 8.82 8.82 0 0 1 2.95-6.55 8.85 8.85 0 0 1 5.797-2.202c3.045-.01 5.913 1.564 7.502 4.204"
    />
  </svg>
);
export default Refresh;
